export class SearchPackageModel {
  cityCode: string;
  countryCode: string;
  city: string;
  checkIn?: Date;
  roomType: string;
  type: string;
  recaptchaToken?: string;
  flightSourcesDefault?: string;

  constructor(params?: URLSearchParams, recaptchaToken?: string) {
    if (params) {
      const paramsObj = Object.fromEntries(params.entries());
      this.cityCode = paramsObj.cityCode;
      this.countryCode = paramsObj.countryCode;
      this.checkIn = new Date(paramsObj.checkIn);
      this.roomType = paramsObj.roomType;
      this.type = paramsObj.type;
      this.city = paramsObj.city;
      this.recaptchaToken = recaptchaToken;
      this.flightSourcesDefault = paramsObj.flightSourcesDefault;
    } else {
      const initSiteDataStr = localStorage.getItem('initSiteData');
      const initSiteData = initSiteDataStr ? JSON.parse(initSiteDataStr) : {};
      this.cityCode = '';
      this.countryCode = '';
      this.roomType = '';
      this.type = '';
      this.city = '';
      this.flightSourcesDefault = initSiteData?.other?.packageFlightSourcesDefault || 'ALP';
    }
  }
}
